import styled from "styled-components";
export const Styles = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  .switch-container {
    width: 180px;
    border-radius: 5px;
    border: 1px solid gray;
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    .service {
      color: ${({ orderOption }) => (orderOption === "service" ? "white" : "#114787")};;
      z-index: 2;
    }
    .offer {
      color: ${({ orderOption }) => (orderOption === "offer" ? "white" : "#114787")};;
      z-index: 2;
    }
    &::after {
      position: absolute;
      z-index: 1;
      content: "";
      ${({ orderOption }) =>
        orderOption === "service" ? "left:-38%;" : "left: 38%;"};
      top: -30%;
      height: 200%;
      width: 100%;
      transform: rotate(-60deg);
      background-color: #114787;
      transition: 0.3s;
    }
  }
`;
